import { useLayoutEffect } from 'react';

const useOverflowScroll = () => {
  useLayoutEffect(() => {
    const priorOverflowY = window.getComputedStyle(document.body).overflowY;
    document.body.style.overflowY = 'scroll';
    return () => {
      document.body.style.overflowY = priorOverflowY;
    };
  }, []);
};

export default useOverflowScroll;
